import * as React from 'react';
import { searchDataSource } from '../../data/SearchDataSource';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

interface ISearchProps {
	text:string;
}

/**
 * used:
 * library.tsx/LibraryPage
 */
@observer
export class Search extends React.Component<ISearchProps> {
	@observable value:string = "";
	@observable isInFocus:boolean = false;

  componentDidMount(){
    searchDataSource.addListener(this.handleSearchDataChange);
    this.handleSearchDataChange();
  }

  componentWillUnmount() {
    searchDataSource.removeListener(this.handleSearchDataChange);
	}
	
  handleSearchDataChange = () => {
  	this.value = searchDataSource.getSearchText();
	}
	
	handleChange = (e) => {
		searchDataSource.setSearchText(e.target.value);
	}

	handleFocus = (e) => {
		this.isInFocus = true;
	}

	handleBlur = (e) => {
		this.isInFocus = false;
	}

	handleClearSearch = () => {
		searchDataSource.setSearchText('');
	}

	render(){
		return (
			<div key="searchbar" className={`search${this.value!=''?' has-text':''}${this.isInFocus?' focused':''}`}>
				<input key="searchinput" ref="searchInput" id="search" placeholder={this.props.text} value={this.value} onChange={this.handleChange} onFocus={this.handleFocus} onBlur={this.handleBlur}/>
				<i className="icon-magnifying-glass"></i>
				{this.value && <a onClick={this.handleClearSearch}><i className="icon-close-x"></i></a> }
			</div>
		)
	}
}

